import React from "react"
import { ResourceSetProvider } from "./src/context/ResourceSetContext"

export const wrapRootElement = ({ element }) => (
  <ResourceSetProvider>{element}</ResourceSetProvider>
)
